import { useUnleash } from '@/package';

import type { Extrinsic } from '../type';

const useGetCamData = () => {
  const { getVariantPayloadValue } = useUnleash();
  const getCamData = () =>
    getVariantPayloadValue('vuex.sapporo.renderBoxInCamImage') as
      | {
          2502830: {
            [K in 'fc1' | 'front' | 'left' | 'rear' | 'right']: {
              extrinsic: Extrinsic;
            };
          };
        }
      | undefined;

  return { getCamData };
};

export default useGetCamData;
